import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from '../util/withRouter';
import { connect } from 'react-redux';

export default function (ComposedComponent) {
  class RequireDashboardAccess extends Component {
    static contextTypes = {
      router: PropTypes.object,
    };

    redirect(to) {
      global.window && window.location && window.location.replace(to + window.location.search);
    }

    render() {
      const { user, routeParams, route } = this.props;

      if (this.props.isLoading) {
        return <div></div>;
      }

      if (!user.permissions) {
        this.redirect('/');
        return null;
      }

      if (route.path.indexOf('permissions') > -1) {
        if (
          !routeParams.id || (
            !user.permissions.manageDashboards &&
            !user.permissions.manageDashboardsViewOnly &&
            (
              !user.permissions.dashboards ||
              !user.permissions.dashboards.length ||
              user.permissions.dashboards.map(d => d.dashboardId).indexOf(routeParams.id) === -1
            )
          )
        ) {
          this.redirect('/users');
          return null;
        }

      } else if (route.path.indexOf('dashboards') > -1) {

        if (
          !user.permissions.manageDashboards &&
          !user.permissions.manageDashboardsViewOnly &&
          (!user.permissions.dashboards || !user.permissions.dashboards.length) 
        ) {
          this.redirect('/users');
          return null;
        }
      }

      return <ComposedComponent {...this.props} />;
    }
  }

  function mapStateToProps(state) {
    return {
      user: state.auth.user,
      isLoading: state.auth.isLoading,
    };
  }

  return withRouter(connect(mapStateToProps)(RequireDashboardAccess));
}
